var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gonggao"},[_vm._m(0),_c('div',{staticClass:"content"},[_c('h3',[_vm._v(_vm._s(_vm.gsgg && _vm.gsgg.title ? _vm.gsgg.title : '暂无公告'))]),_c('p',{domProps:{"innerHTML":_vm._s(_vm.gsgg && _vm.gsgg.content ? _vm.gsgg.content : '')}}),_c('router-link',{attrs:{"to":{
        name: '公示公告详情',
        query: { id: _vm.gsgg && _vm.gsgg.id ? _vm.gsgg.id : '' },
      }}},[_vm._v(_vm._s(_vm.gsgg && _vm.gsgg.id ? '【详情】' : ''))])],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"mode"},[_c('span',[_vm._v("公示公告")])])
}]

export { render, staticRenderFns }